import { FormControl, MenuItem, Select } from "@mui/material";
import React from "react";
import { useDispatch } from "react-redux";
import {
  updateItemQuestion,
  updateNumberRanger,
} from "../../Redux/Reducer/FormSlices";
import ReactQuill from "react-quill";

const LineScaleQuestion = ({
  question,
  id,
  questionIndex,
  module,
  openQuestion,
  setOpenQuestion,
  containerIndex,
}) => {
  const dispatch = useDispatch();
  const handleQuestionChange = (newQuestion) => {
    dispatch(
      updateItemQuestion({ newQuestion, questionIndex, containerIndex })
    );
  };
  const handleMaxRangeChange = (value, name) => {
    dispatch(
      updateNumberRanger({ value, name, questionIndex, containerIndex })
    );
  };
  return (
    <>
      <div className="singleQuestion_name_Container">
        {questionIndex + 1}.
        <ReactQuill
          modules={module}
          theme="snow"
          className={`custom ${openQuestion === question.id ? "focus" : ""}`}
          onFocus={() => setOpenQuestion(question.id)}
          onBlur={() => setOpenQuestion(null)}
          value={question.question}
          onChange={(html) => handleQuestionChange(html)}
        />
      </div>
      <div
        style={{
          marginTop: "2.5rem",
          display: "flex",
          alignItems: "center",
          gap: "1.875rem",
        }}
      >
        <FormControl variant="standard" sx={{ m: 1, minWidth: 80 }}>
          <Select
            value={question.minRange.value}
            onChange={(e) =>
              handleMaxRangeChange(e.target.value, e.target.name)
            }
            displayEmpty
            name="minRange"
            inputProps={{ "aria-label": "Without label" }}
          >
            <MenuItem value={0}>0</MenuItem>
            <MenuItem value={1}>1</MenuItem>
          </Select>
        </FormControl>
        <p>to</p>
        <FormControl variant="standard" sx={{ m: 1, minWidth: 80 }}>
          <Select
            value={question.maxRange.value}
            onChange={(e) =>
              handleMaxRangeChange(e.target.value, e.target.name)
            }
            displayEmpty
            name="maxRange"
            inputProps={{ "aria-label": "Without label" }}
            className="MuiSelect-select"
          >
            <MenuItem value={2}>2</MenuItem>
            <MenuItem value={3}>3</MenuItem>
            <MenuItem value={4}>4</MenuItem>
            <MenuItem value={5}>5</MenuItem>
            <MenuItem value={6}>6</MenuItem>
            <MenuItem value={7}>7</MenuItem>
            <MenuItem value={8}>8</MenuItem>
            <MenuItem value={9}>9</MenuItem>
            <MenuItem value={10}>10</MenuItem>
          </Select>
        </FormControl>
      </div>
      <div className="lineScale_text">
        <div
          style={{
            display: "flex",
            height: "1.8rem",
            width: "100%",
            alignItems: "center",
          }}
        >
          {question.minRange.value}.
          <input
            className="Name"
            style={{ fontSize: "1rem" }}
            name="minValue"
            onChange={(e) =>
              handleMaxRangeChange(e.target.value, e.target.name)
            }
            value={question.minValue}
          />
        </div>
        <div
          style={{
            display: "flex",
            height: "1.8rem",
            width: "100%",
            alignItems: "center",
          }}
        >
          {question.maxRange.value}.
          <input
            className="Name"
            style={{ fontSize: "1rem" }}
            value={question.maxValue}
            name="maxValue"
            onChange={(e) =>
              handleMaxRangeChange(e.target.value, e.target.name)
            }
          />
        </div>
      </div>
    </>
  );
};

export default LineScaleQuestion;
